<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <section class="phero">
    <div class="wrap">
      <span class="eyebrow"><span class="dot"></span>Resources</span>
      <h1>Resources</h1>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ResourcesPage',
};
</script>
